import React from 'react';
import styled from '@emotion/styled';
import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
import 'external-svg-loader';
import { CSSObject } from '@emotion/css';

const { mqBreakpoints, pxToRem } = StyleLibrary;

const titleHoverStyleRules: CSSObject = {
  color: 'var(--color-hover)',
  textDecoration: 'underline',
};

type Props = {
  title: string;
  expanded?: boolean;
  onChange: (event: React.ChangeEvent<{}>, isExpanded: boolean) => void;
};

type AccordionIconContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  expanded?: boolean;
};

const AccordionIconContainer = styled.div<AccordionIconContainerProps>({});

type AccordionIconProps = React.HTMLAttributes<SVGElement> & {
  expanded?: boolean;
};

const AccordionIcon = styled.svg<AccordionIconProps>(props => ({
  width: pxToRem(24),
  height: pxToRem(24),
  fill: 'var(--color-primary)',
  transform: props.expanded ? 'rotate(45deg)' : 'rotate(0deg)',
  transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
}));

const AccordionTitle = styled.h3({
  flexGrow: '1',
  fontFamily: 'var(--font-heading)',
  fontSize: pxToRem(16),
  fontWeight: 'var(--font-weight-medium)' as any,
  letterSpacing: 'normal',
  lineHeight: pxToRem(24),
  margin: '0 0.6rem 0 0',
  padding: `${pxToRem(24)} 0`,

  [mqBreakpoints.tablet]: {
    margin: 0,
  },
});

type AccordionHeaderContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  expanded?: boolean;
};

const AccordionHeaderContainer = styled.div<AccordionHeaderContainerProps>(props => ({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  cursor: 'pointer',
  paddingRight: pxToRem(16),
  '&:hover': titleHoverStyleRules,
  color: props.expanded ? 'var(--color-hover)' : 'var(--color-body)',
}));

export const AccordionHeader: React.FC<Props> = ({ title, expanded, onChange }) => {
  const handleKeyDown = (e: React.KeyboardEvent<{}>) => {
    if (e.code === 'Enter') {
      onChange(e, !expanded);
    }
  };

  return (
    <AccordionHeaderContainer role='button' data-testid='mp-accordion-header' tabIndex={0} onKeyDown={handleKeyDown} onClick={e => onChange(e, !expanded)} aria-expanded={expanded} expanded={expanded}>
      <AccordionTitle>{title}</AccordionTitle>
      <AccordionIconContainer>
        <AccordionIcon expanded={expanded} data-src={`${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/shared/plus.svg`} data-testid={'mp-accordion-header-svg'} />
      </AccordionIconContainer>
    </AccordionHeaderContainer>
  );
};
